export default "__VITE_ASSET__DunD_oRk__"